module.exports = __webpack_public_path__ + "media/images/pic/team-people-f89893cb852142371d6b79d0e82e2c06.jpeg";